<template>
  <div class="kpi-card">
    <div class="card h-100">
      <div class="card-body">
        <div v-if="loading" class="text-center py-4">
          <a-spin size="large" />
        </div>
        <div v-else>
          <div class="d-flex justify-content-between align-items-start mb-3">
            <div class="kpi-icon" :style="{ backgroundColor: color + '20', color: color }">
              <a-icon :type="icon" />
            </div>
            <div class="text-right">
              <div class="trend-indicator" :class="getTrendClass()">
                <a-icon :type="getTrendIcon()" />
                <span class="ml-1">{{ trend }}%</span>
              </div>
            </div>
          </div>
          
          <div class="kpi-content">
            <h3 class="kpi-value mb-2" :style="{ color: color }">
              {{ formatValue(value) }}
            </h3>
            <h6 class="kpi-title mb-1">{{ title }}</h6>
            <p class="kpi-subtitle text-muted mb-0">{{ subtitle }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KpiCard",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String],
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "#1890ff"
    },
    icon: {
      type: String,
      default: "dollar"
    },
    trend: {
      type: [Number, String],
      default: 0
    }
  },
  methods: {
    formatValue(value) {
      if (typeof value === 'string') return value;
      if (!value && value !== 0) {
        return '0';
      }
      if (value >= 1000000) {
        return (value / 1000000).toFixed(1) + 'M';
      } else if (value >= 1000) {
        return (value / 1000).toFixed(1) + 'K';
      }
      return value.toLocaleString();
    },
    
    getTrendClass() {
      const trendNum = parseFloat(this.trend);
      if (trendNum > 0) return 'trend-positive';
      if (trendNum < 0) return 'trend-negative';
      return 'trend-neutral';
    },
    
    getTrendIcon() {
      const trendNum = parseFloat(this.trend);
      if (trendNum > 0) return 'arrow-up';
      if (trendNum < 0) return 'arrow-down';
      return 'minus';
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/shared.scss';

.kpi-card {
  // All styles are now in shared.scss
}
</style>
